module.exports = __webpack_public_path__ + "media/images/icon_like_filled-294363c63c26b0c7f1d05b36fdcf79d1.svg";